'use strict';

require('./CompanyPublicationService');
require('./CompanyPublicationMassEditCtrl.js');

function CompanyPublicationsListArchivedCtrl($scope, $stateParams, $state, publications, priorities, translations, CompanyPublicationService, growl, $modal) {
  $scope.publications = publications.map(function(item) {
    // TODO: Should this be configurable?
    if(item.category) {
      item.category.color = 4291809231; // Light gray (#cfcfcf);
    } else {
      item.category = {
        color: 4291809231
      };
    }
    return item;
  });
  $scope.$state = $state;
  $scope.priorityId = $stateParams.priorityId || null;
  $scope.more = false;
  $scope.title = translations['publication.archived'];
  $scope.listArchived = true;

  if($scope.publications.length === 21) {
    $scope.more = true;
    $scope.publications.pop();
  }

  $scope.filter = {};
  if ($stateParams.queryArchived) {
    $scope.filter.q = $stateParams.queryArchived;
  }

  $scope.showPublicationForm = false;
  $scope.publicationsMassEdit = [];
  $scope.namePublications = [];
  $scope.goToPublicationDetail = function(publication){
    if(publication.type !== 'FORM' && publication.type !== 'PUBLICATION_SPREAD_SHEET' && publication.type !== 'COMPANY_ORDER' && publication.type !== 'ORDER_SUBCRIPTION'){
      $state.go('root.company.publication.detail', {companyId: $stateParams.companyId, publicationId: publication.id});
    }else{
      if(publication.type === 'PUBLICATION_SPREAD_SHEET'){
        window.location.href = '/spreadsheet/'+$stateParams.companyId+'/publications/'+publication.id;
      }
      if(publication.type === 'FORM'){
        if (
          publication.features.formActived === "false" ||
          !!publication.features.formActived === false
        ) {
          window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/detail';
        }else{
          window.location.href = '/forms/companies/'+$stateParams.companyId+'/publications/'+publication.id+'/form-submit';
        }
      }
      if(publication.type === 'COMPANY_ORDER'){
        window.location.href = '/order/'+$stateParams.companyId+'/detail/'+publication.id;
      }
      if(publication.type === 'ORDER_SUBCRIPTION'){
        window.location.href = '/order/'+$stateParams.companyId+'/subcription-detail/'+publication.id;
      }
    }
  };
 
  $scope.addPublicationsMassEdit = function(publication, publicationSelected){
    if(publicationSelected){
      $scope.publicationsMassEdit.push(publication.id);
      $scope.namePublications.push(publication);
    }else{
      $scope.publicationsMassEdit.splice($scope.publicationsMassEdit.indexOf(publication.id), 1);
      $scope.namePublications.splice($scope.namePublications.indexOf(publication), 1);
    }
  };

  $scope.selectAllPublication = function(){
    $scope.selectAll = !$scope.selectAll;
    angular.forEach($scope.publications, function(publication){
      if($scope.selectAll){
        publication.selected = true;
        $scope.publicationsMassEdit.push(publication.id);
        $scope.namePublications.push(publication);
      }else{
        publication.selected = false;
        $scope.publicationsMassEdit = [];
        $scope.namePublications = [];
      }
    });
  };
 
  $scope.showModalMassEdit = function() {
    $modal({
      scope: $scope,
      controller: 'CompanyPublicationMassEditCtrl',
      templateUrl: 'partials/company/publications/lists/mass-edit-modal.html',
      show: true,
      resolve: {
        priorities: function() {
          return priorities;
        },
        groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
          return CompanyGroupService.query({
            companyId: $stateParams.companyId,
            all: true
          }).$promise;
        }],
        categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
          return CompanyCategoryService.query({
            companyId: $stateParams.companyId,
            limit: 1000
          }).$promise;
        }]
      }
    });
  };

  $scope.searchPublications = function() {
    $state.go('.', {
      companyId: $stateParams.companyId,
      queryArchived: $scope.filter.q
    });
  };
  
  $scope.$on('$select.select', function(ev, priorityId) {
    $scope.priorityId = priorityId;
    if(!$scope.priorityId) {
      $scope.priorityId = null;
    }
    var filter = {
      priorityId: $scope.priorityId,
      page: null
    };
    $state.go('root.company.publications-listArchived', filter);
  });


  $scope.page = $stateParams.page|0;
  $scope.companyId = $stateParams.companyId;

  $scope.deleteAllArchives = function() {
    CompanyPublicationService.deleteArchives({companyId: $stateParams.companyId}, function(){
      $scope.publications = [];
      growl.addSuccessMessage(translations['company.delete-all-archived-objects-success']);
    }, function(){
      growl.addErrorMessage(translations['company.delete-all-archived-objects-failure']);
    });
  };

}

CompanyPublicationsListArchivedCtrl.resolve = {
  publications: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    var filter = {
      companyId: $stateParams.companyId,
      offset:    ($stateParams.page|0) * 20,
      limit:     21,
      archived:  true,
      q: $stateParams.queryArchived || ""
    };

    if ('' !== $stateParams.priorityId) {
      filter.priorityId = $stateParams.priorityId;
    }

    return CompanyPublicationService.query(filter).$promise;
  }],
  priorities: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.queryPriorities({companyId: $stateParams.companyId});
  }],
  translations: ['$translate', function($translate) {
    return $translate(['publication.list-drafts', 'publication.archived', 'company.delete-all-archived-objects-success', 'company.delete-all-archived-objects-failure']);
  }]
};
module.exports = CompanyPublicationsListArchivedCtrl;

angular.module('dokiv')
  .controller('CompanyPublicationsListArchivedCtrl', ['$scope', '$stateParams', '$state', 'publications', 'priorities', 'translations', 'CompanyPublicationService', 'growl', '$modal', CompanyPublicationsListArchivedCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationsListArchivedCtrl.js
// module id = 384
// module chunks = 0